
import { useMaterialUIController, setSearchTerm } from "context";

const initialSearch = {
  text:'', 
  filters:{name:'', province:'', category:'',price:'', color:'', store:'', productName:'', radius :0},
  message:{filters:{content:'',search:""}, page:0, sortBy:'dateASC', entriesPerpage : 25},
  sortBy:'dateASC', 
  page:0, 
  entriesPerpage : 20
}
const useSearch = () => {
  const [controller, dispatch] = useMaterialUIController();
  const { searchTerm } = controller;
  const filterSearch = search => setSearchTerm(dispatch, {...searchTerm, ...search });
  const unsetSearch  = () => setSearchTerm(dispatch, initialSearch);
  return { unsetSearch , searchTerm, filterSearch }
}

export default useSearch